import React, { Component } from 'react';
import { func, bool, node } from 'prop-types';
import { connect } from 'react-redux';
import { Icon, SearchIcon } from '@axiom/ui';

import {
  closeSideBar,
  openSideBar,
  deactivateSideBar,
  activateSideBar,
  activateSideDrawer,
  deactivateSideDrawer,
} from '../../redux/actions/app';
import { sideBarSelector } from '../../redux/selectors/app';
import { formatDataTestId } from '../../utils/data-test-util';
import { AiSearchContextProvider } from '../../providers/AiSearchContextProvider';

import { BarTab, StyledWrapper } from './SidebarStyles';

class Sidebar extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { transitionOpened: false };
  }

  openPanel = panel => {
    const { sideBarIsExpanded } = this.props;
    const { context } = this;
    const activePanel = context?.activePanel ?? 'search';

    if (sideBarIsExpanded && activePanel === panel) {
      this.props.closeSideBar();
      this.props.deactivateSideBar();
    } else {
      context?.setActivePanel(panel);
      if (!sideBarIsExpanded) {
        this.props.openSideBar();
        this.props.deactivateSideDrawer();
        this.props.activateSideBar();
      }
    }
  };

  render() {
    const {
      props: { sideBarIsExpanded, sideBarActive, children, aiSearchContent },
      state: { transitionOpened },
    } = this;
    const { context } = this;
    const activePanel =
      aiSearchContent && context?.activePanel ? context.activePanel : 'search';

    return (
      <StyledWrapper>
        <BarTab
          data-test={formatDataTestId('sidebarTab')}
          aria-controls="sidebar"
          aria-expanded={sideBarIsExpanded}
          expanded={sideBarIsExpanded}
          onClick={() => this.openPanel('search')}
          type="button"
          active={sideBarActive ? activePanel === 'search' : null}
          data-opened={sideBarIsExpanded}
        >
          <SearchIcon />
        </BarTab>
        {aiSearchContent ? (
          <BarTab
            data-test={formatDataTestId('aiSearchSidebarTab')}
            aria-controls="sidebar"
            aria-expanded={
              sideBarIsExpanded ? activePanel === 'aiSearch' : null
            }
            expanded={sideBarIsExpanded ? activePanel === 'aiSearch' : null}
            onClick={() => this.openPanel('aiSearch')}
            type="button"
            active={sideBarActive ? activePanel === 'aiSearch' : null}
            data-opened={sideBarIsExpanded ? activePanel === 'aiSearch' : null}
            secondTab
          >
            <Icon name="intelligence" />
          </BarTab>
        ) : null}
        <section
          id="sidebar"
          data-test={formatDataTestId('sidebar')}
          data-ready={transitionOpened}
          data-expanded={sideBarIsExpanded}
          onTransitionEnd={evt => {
            if (evt.target.tagName === 'SECTION') {
              this.setState({ transitionOpened: !transitionOpened });
            }
          }}
        >
          <div className="content" hidden={!sideBarIsExpanded}>
            {activePanel === 'search' ? children : aiSearchContent}
          </div>
        </section>
      </StyledWrapper>
    );
  }
}

Sidebar.contextType = AiSearchContextProvider;

Sidebar.defaultProps = {
  aiSearchContent: null,
  children: null,
  sideBarActive: false,
  sideBarIsExpanded: false,
};

Sidebar.propTypes = {
  activateSideBar: func.isRequired,
  aiSearchContent: node,
  children: node,
  closeSideBar: func.isRequired,
  deactivateSideBar: func.isRequired,
  deactivateSideDrawer: func.isRequired,
  openSideBar: func.isRequired,
  sideBarActive: bool,
  sideBarIsExpanded: bool,
};

export default connect(sideBarSelector, {
  closeSideBar,
  openSideBar,
  activateSideBar,
  deactivateSideBar,
  activateSideDrawer,
  deactivateSideDrawer,
})(Sidebar);
